import React, { useEffect } from 'react';

const BookingCalendar = () => {
  useEffect(() => {
    (function (C, A, L) {
      let p = function (a, ar) {
        a.q.push(ar);
      };
      let d = C.document;
      C.Cal =
        C.Cal ||
        function () {
          let cal = C.Cal;
          let ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement('script')).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api = function () {
              p(api, arguments);
            };
            const namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === 'string') {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              p(cal, ['initNamespace', namespace]);
            } else p(cal, ar);
            return;
          }
          p(cal, ar);
        };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');
    window.Cal('init', '15min', { origin: 'https://app.cal.com' });

    window.Cal.ns['15min']('inline', {
      elementOrSelector: '#my-cal-inline-15min',
      config: { layout: 'month_view', theme: 'light' },
      calLink: 'ilyalabs/15min',
    });

    window.Cal.ns['15min']('ui', {
      theme: 'light',
      hideEventTypeDetails: false,
      layout: 'month_view',
    });
  }, []);

  return (
    <div id="booking-section" className="py-12 bg-white relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden max-w-5xl mx-auto">
          <div
            style={{ width: '100%', height: '700px', overflow: 'scroll' }}
            id="my-cal-inline-15min"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default BookingCalendar;